
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPipeGoingTo as ObiPipeGoingToElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pipe-going-to.js';
 
 
 

 
 export const ObiPipeGoingTo = createComponent({
   react: React,
   tagName: 'obi-pipe-going-to',
   elementClass: ObiPipeGoingToElement,
   events: {
     
   }
  });
 
 